import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawSdvTri2Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "sdv-tri-2";
		this.icon = svg_sdv_tri_2;
	}
}

window.customElements.define("inspx-draw-sdv-tri-2-module", DrawSdvTri2Module);

const svg_sdv_tri_2 = html`
<svg width="60" height="60" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect height="29.59955" width="29.69966" fill="#ffffff" y="0.23485" x="0.4328" id="svg_8" stroke="#444444"/>
  <rect stroke="#444444" id="svg_2" height="30" width="59.53787" fill="#ffffff" y="29.72241" x="0.17798"/>
  <rect fill="#aaa7a7" stroke="#444444" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="30.03909" y="30.06004" width="29.49994" height="29.23297" id="svg_5"/>
  <line stroke="#444444" id="svg_1" y2="29.72241" x2="30.17798" y1="59.72241" x1="30.17798" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="none"/>
  <text style="cursor: move;" stroke="#444444" transform="matrix(1.748146119803863,0,0,1,-3.435311616745808,0) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_4" y="52.88717" x="19.17705" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">DV</text>
  <text id="svg_3" stroke="#444444" transform="matrix(1.748146119803863,0,0,1,-3.435311616745808,0) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" y="22.57402" x="10.83614" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">S</text>
  <line id="svg_6" stroke="#444444" y2="-0.36582" x2="0.16786" y1="29.63418" x1="0.16786" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="none"/>
 </g>
</svg>`;
